export default `
    ... on ds_Logos_GlobalSet {
        id
        name
        logos_StickyNavLogoSize
        logos_StickyNavLogo {
            url
        }
        logos_HeaderLogoSize
        logos_HeaderLogo {
            url
        }
        logos_FooterLogoSize
        logos_FooterLogo {
            url
        }
        logos_BrowserIcon {
            url
        }
        logos_PlaceholderImage {
            url
            alt
            focalPoint
        }
    }
`